<script>
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import groupBy from "lodash/groupBy";
import cloneDeep from "lodash/cloneDeep";
import Tracks from "@/components/modals/document-tracks.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import { drop } from "lodash";
export default{
    name: "TrackModal",
    components: {
        Multiselect,
        Tracks,
        UploadPopover
    },
    props: {
        modalTitle: {
          type: String,
          default: "Create Document Track",
        },
        selectedSendAs: {
          type: String,
          default: 'office',
        },
        processTypeOptions: {
          type: Array,
          default: () => [],
        },
        actionTypeOptions: {
          type: Array,
          default: () => [],
        },
        sendAsOptions: {
          type: Array,
          default: () => [],
        },
        type: {
          type: String,
          default: "create",
        },
    },
    data() {
        return {
            loading: false,
            form: {
                deliveryUnitId: "",
                departmentId: "",
                title: "",
                description: "",
                destinationDepartmentId: "",
                destinationDepartment: [{ departmentName: "N/A", id: 0 }],
                destinationDeliveryUnitId: "",
                destinationDeliveryUnit: null,
                destinationCampus: null,
                processTypeId: "",
                processType: null,
                actionNeeded: "",
                actionType: null,
                documents: [],
                document: "",
                tracks: [],
                attachments: [],
                trackDestinationDeliveryUnitIds: [],
            },
            submitted: false,
            campusOptions: [],
            departmentOptions: [],
            attachments: [],
            uploadOptions: {
              type: "DTS Tracks",
              placement: "right",
              folder: "DTS",
            },
            addDocu: false,
            loadCampus: false,
            actionTaken: "",
            showAllCampus: false,
            dus: [],
            processTypesDUs: []
        }
    },
    validations: {
        form: {
          title: { required },
          description: { required },
          destinationDeliveryUnit: { required },
          destinationCampus: { required },
          processType: { required },
          actionType: { required },
          documents: { required }
        },
        actionTaken: { required }
    },
    watch: {
      'form.trackDestinationDeliveryUnitIds': function (newVal) {
        if(newVal.length){
          this.form.destinationDepartment = null;
          this.form.destinationDepartmentId = "";
          this.form.destinationDeliveryUnit = newVal[0];
          this.form.destinationDeliveryUnitId = 0;
          this.getDepartment(newVal[0].id);
        }else{
          this.form.destinationDepartment = null;
          this.form.destinationDepartmentId = "";
          this.form.destinationDeliveryUnit = null;
          this.form.destinationDeliveryUnitId = 0;
        }
      },
      "showAllCampus": function(value) {
        this.form.destinationCampus = null;
        this.form.destinationDeliveryUnit = null;
        this.form.trackDestinationDeliveryUnitIds = [];
        this.form.destinationDepartment = null;
        this.form.destinationDepartmentId = "";
        if(value){
          this.campusOptions = this.groupDu(this.dus);
        }else{
          this.campusOptions = this.groupDu(this.processTypesDUs);
        }
      },
    },
    created() {
      this.getAllDUs();
    },
    methods: {
        async getAllDUs() {
          this.$store
            .dispatch("deliveryunit/GetDeliveryUnit")
            .then((res) => {
              if(res.data.error){
                return this.showToast(res.data.errorMessage, "error");
              }
              this.dus = res.data.sort(function(a, b) {
                if (a.name.trim() .trim()< b.name.trim()) {
                  return -1;
                }
                if (a.name.trim() > b.name.trim()) {
                  return 1;
                }
                return 0;
              }).filter(item => !item.office.campus.campusName.toLowerCase().includes('test')).map((item) => {
                return {
                  id: item.id,
                  name: item.name.trim(),
                  campusId: item.office.campusId,
                  campus: item.office.campus.campusName
                };
              });
            })
            .catch((err) => {
              this.showToast("Something went wrong - Getting campuses!", "error");
            });
        },
        processTypeLabel({ processName }) {
            return `${processName}`;
        },
        actionTypeLabel({ type }) {
            return `${type}`;
        },
        campusLabel({ campus }) {
            return `${campus}`;
        },
        deliveryUnitLabel({ name }) {
            return `${name}`;
        },
        departmentLabel({ departmentName }) {
            return `${departmentName}`;
        },
        changeDestinationCampus(){
          this.form.destinationDeliveryUnit = null;
          this.form.trackDestinationDeliveryUnitIds = [];
        },
        async onReset() {
          this.submitted = false;
          this.form = {
              deliveryUnitId: this.$store.state.data.selectedDU.id,
              departmentId: 0,
              title: "",
              description: "",
              destinationDepartmentId: "",
              destinationDepartment: [{ departmentName: "N/A", id: 0 }],
              destinationDeliveryUnitId: "",
              trackDestinationDeliveryUnitIds: [],
              destinationDeliveryUnit: null,
              destinationCampus: null,
              processTypeId: "",
              processType: null,
              actionNeeded: "",
              actionType: null,
              documents: [],
              document: "",
              tracks: [],
              attachments: [],
          };
          this.actionTaken = "";
          this.$v.$reset();
          this.attachments = []
        },
        async updateData(data){
          this.loading = true;
          this.onReset();
          await this.getAttachments(data);
          await this.getDocuments(data);
          await this.getDeliveryUnit(data.processType.id);
          let dropData = JSON.parse(JSON.stringify(data));
          this.showAllCampus = await this.determineIfShowAll(dropData);
          await this.wait(500);
          let dus = await this.getUpdatedDU(dropData);
          this.form = {
            id: dropData.id,
            deliveryUnitId: dropData.deliveryUnitId,
            departmentId: dropData.departmentId,
            title: dropData.title,
            description: dropData.description,
            destinationDepartmentId: dropData.destinationDepartmentId,
            destinationDepartment: dropData.destinationDepartment ? dropData.destinationDepartment : [{ departmentName: "N/A", id: 0 }],
            destinationDeliveryUnitId: dropData.destinationDeliveryUnitId,
            destinationDeliveryUnit: dropData.destinationDeliveryUnit,
            destinationCampus: this.campusOptions.find((x) => x.campusId == dropData.destinationDeliveryUnit.campusId),
            trackDestinationDeliveryUnitIds: dus,
            processTypeId: dropData.processTypeId,
            processType: dropData.processType,
            actionNeeded: dropData.actionNeeded,
            actionType: { type: dropData.actionNeeded },
            documents: dropData.documents,
            document: "",
            tracks: dropData.trackDocuments,
            attachments: [],
          }
          this.loading = false;
        },
        async determineIfShowAll(data){
          let fCamp = this.campusOptions.find((x) => x.campusId == data.destinationDeliveryUnit.campusId)
          if(!fCamp){
            return true;
          }
          let miss = 0;
          for await(const item of fCamp.deliveryUnitOptions){
            let fDu = data.trackDestinationDeliveryUnits.find(x => x.deliveryUnitId == item.id);
            if(!fDu){
              miss++;
            }
          }
          if(miss > 0){
            return true;
          }
          return false;
        },
        async getUpdatedDU(data){
          let fCamp = this.campusOptions.find((x) => x.campusId == data.destinationDeliveryUnit.campusId)
          let array = [];
          if(!data.trackDestinationDeliveryUnits || !data.trackDestinationDeliveryUnits.length){
            return [data.destinationDeliveryUnit];
          }
          for await (const item of data.trackDestinationDeliveryUnits){
            let fDu = fCamp.deliveryUnitOptions.find(x => x.id == item.deliveryUnitId);
            if(fDu){
              array.push(fDu);
            }
          }
          return array;
        },
        async forwardTrack(props) {
          this.loading = true;
          this.onReset();
          await this.getAttachments(props);
          await this.getDocuments(props);
          this.form.title = JSON.parse(JSON.stringify(props.title));
          this.form.description = JSON.parse(JSON.stringify(props.description));
          this.form.parentId = JSON.parse(JSON.stringify(props.id));
          this.form.requestedAction = JSON.parse(JSON.stringify(props.actionNeeded));
          this.form.documents = JSON.parse(JSON.stringify(props.documents));
          this.attachments.map(item => {
            item.id = 0;
          })
          this.loading = false;
        },
        async getAttachments(data){
          this.attachments = [];
          await this.$store
            .dispatch("filemanager/GetFiles", {id: data.id, type: this.uploadOptions.type, removeLoading: true})
            .then((res) => {
                if(res.data.error){
                  return this.showToast(res.data.errorMessage, "error");
                }
                this.attachments = res.data;
            })
            .catch(() => {
                this.showToast('Something went wrong! - getting documents', "error");
            });
        },
        onSubmit(type){
            this.submitted = true;
            this.$v.form.$touch();
            this.$v.actionTaken.$touch();
            if (this.$v.form.$invalid || this.form.documents.length == 0 || (this.type == 'forward' && this.actionTaken.$invalid)) {
              return;
            }
            let data = JSON.parse(JSON.stringify(this.form));
            let dus = this.form.destinationCampus ? this.form.destinationCampus.deliveryUnitOptions.filter(item => this.form.trackDestinationDeliveryUnitIds.some(x => x.id == item.id)) : [];
            data.destinationDeliveryUnitId = this.form.destinationDeliveryUnit.id;
            data.destinationDepartmentId = this.form.destinationDepartment.id;
            data.processTypeId = this.form.processType.id;
            data.sendType = type;
            data.actionTaken = this.type == 'forward' ? this.actionTaken : '';
            data.trackDestinationDeliveryUnitIds = this.form.trackDestinationDeliveryUnitIds.map(item => item.id);
            data.trackDestinationDeliveryUnits = dus;
            let sendAttachments = this.attachments.filter(item => item.id == 0);
            this.$emit('submit', { ...data, attachments: sendAttachments });
        },
        async changeProcessType() {
            this.form.actionNeeded = "";
            this.form.actionType = null;
            this.form.destinationDepartmentId = "";
            this.form.destinationDepartment = [{ departmentName: "N/A", id: 0 }];
            this.form.destinationDeliveryUnitId = "";
            this.form.destinationDeliveryUnit = null;
            this.form.destinationCampus = null;
            this.loadCampus = true;
            await this.getDeliveryUnit(this.form.processType.id);
            this.loadCampus = false;
            this.form.destinationCampus = this.campusOptions[0];
        },
        groupDu(props) {
            var array = [];
            var x = groupBy(props, "campusId");
            for (const key in x) {
                array.push({
                campusId: key,
                campus: x[key][0].campus,
                deliveryUnitOptions: x[key]
              });
            }
            return array;
        },
        async getDeliveryUnit(processId) {
          await this.$store
            .dispatch("dtsprocesstype/GetDUByProcessType", processId)
            .then((res) => {
            if (res.data.error) {
              return;
            }
            this.processTypesDUs = res.data.sort(function(a, b) {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            });
            this.campusOptions = this.groupDu(this.processTypesDUs);
          });
        },
        async getDepartment(duId) {
            this.form.destinationDepartment = [{ departmentName: "N/A", id: 0 }];
            this.$store.dispatch("department/GetDepartmentByDU", duId).then((res) => {
                if (res.data.error || res.data.length < 2) {
                return;
                }
                this.departmentOptions = res.data
                .sort(function (a, b) {
                    if (a.departmentName < b.departmentName) {
                    return -1;
                    }
                    if (a.departmentName > b.departmentName) {
                    return 1;
                    }
                    return 0;
                })
                .filter((item) => {
                    return this.$store.state.data.selectedDepartment.id != item.id;
                });
                this.departmentOptions.unshift({ departmentName: "N/A", id: 0 });
            });
        },
        async getDocuments(props) {
          await this.$store
            .dispatch("dtstrackdocument/GetTrackDocument", props.id)
            .then((res) => {
              if(res.data.error) {
                return;
              }
              props.documents = res.data.map(item => item.title);
            });
        },
        addDocument() {
          if (this.form.document.trim() != "") {
            this.form.documents.push(this.form.document);
            this.form.document = "";
          }
        },
        removeDocument(index) {
          this.form.documents.splice(index, 1);
        },
        getTracks() {
          this.$refs.tracks.setData(this.form.tracks, this.$store.state.data.selectedDU.id, this.selectedSendAs === 'office' ? 0 : this.$store.state.data.selectedDepartment.id);
          this.$bvModal.show("tracks-modal");
        },
        dropTracks(data) {
          this.form.tracks = data.concat(this.form.tracks);
        },
        setLoading(value) {
          this.loading = value;
        },
        uploadedFiles(data) {
          this.attachments = this.attachments.concat(data);
        },
        removeAttachment(item, index) {
          if(item.id == 0){
            this.attachments.splice(index, 1);
            return;
          }
          this.$swal({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dc3545",
            cancelButtonColor: "#5c636a",
            confirmButtonText: "Yes, delete it!",
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              this.$store
                .dispatch("filemanager/DeleteFile", item.id)
                .then((res) => {
                  if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                  }
                  this.attachments.splice(index, 1);
                  this.showToast("File successfully removed.", "success");
                })
                .catch(() => {
                  this.showToast("Something went wrong! - removing file", "error");
                });
            }
          });
        },
        pushToFiles(data){
          this.attachments = this.attachments.concat(data);
        },
    }
}
</script>
<template>
    <b-modal 
        id="modal-documentTrack" 
        :title="modalTitle" 
        size="xl" 
        title-class="font-18" 
        hide-footer
        no-close-on-backdrop 
        no-close-on-esc
    >
      <div v-if="loading" class="my-5">
        <div class="d-flex align-items-center justify-content-center">
          <div class="preloader-component me-2">
            <div class="status">
              <div class="spinner-chase w-25px h-25px">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="mb-3 bg-info bg-soft px-3 py-2 rounded text-white d-flex gap-2" v-if="type == 'forward'">
          <label for="actionTaken" class="me-2">
            <div>
              <span class="font-size-11 text-nowrap">Requested Action:</span> <br>
              <span class="text-orange font-size-14">{{ form.requestedAction }}</span>
            </div>
          </label>
          <div class="w-100">
            <textarea
              id="actionTaken"
              type="text"
              v-model="actionTaken"
              placeholder="Enter Action Taken..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.actionTaken.$error
              }"
              autocomplete="off"
            />
            <div
              v-if="submitted && $v.actionTaken.$error"
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
        </div>
        <hr v-if="type == 'forward'" />
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3" v-if="($store.state.data.selectedDU.withDeliveryUnitAccess || $store.state.decrypt.isAdmin()) && sendAsOptions.length">
              <label>Send As</label>
              <b-form-radio-group v-model="selectedSendAs" :options="sendAsOptions" name="send-as-options" plain>
              </b-form-radio-group>
            </div>
            <div class="mb-3">
              <label for="title">Title </label>
              <input id="title" type="text" v-model="form.title" placeholder="Enter Title..." class="form-control" :class="{
                'is-invalid': submitted && $v.form.title.$error
              }" autocomplete="off" />
              <div v-if="submitted && $v.form.title.$error" class="invalid-feedback">
                <span v-if="!$v.form.title.required">This value is required.</span>
              </div>
            </div>
            <div class="mb-3">
              <label for="description">Description </label>
              <textarea id="description" type="text" v-model="form.description" placeholder="Enter Description..."
                class="form-control" :class="{
                  'is-invalid': submitted && $v.form.description.$error
                }" autocomplete="off" />
              <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
                <span v-if="!$v.form.description.required">This value is required.</span>
              </div>
            </div>
            <div class="mb-3">
              <label class="mt-2" for="documents">Particulars </label>
              <div>
                <b-input-group>
                  <template #append>
                    <button @click="addDocument()" class="btn btn-success">
                      Add
                    </button>
                  </template>
                  <input autocomplete="off" type="text" placeholder="Enter Particular..." class="form-control" :class="{
                    'is-invalid': submitted && form.documents.length == 0
                  }" v-model="form.document" @keyup.enter="addDocument"/>
                </b-input-group>
                <div v-if="submitted && form.documents.length == 0" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div v-if="form.documents.length > 0" class="mx-3 mt-2 p-2 br-5 border position-relative"
                style="min-height: 40px; background-color: #2e3446">
                <div class="w-100" style="top: 10px; left: 10px; bottom: 10px; right: 10px">
                  <div class="multiselect__tags-wrap">
                    <span class="multiselect__tag" v-for="(document, index) in form.documents" :key="document.id">
                      <span>{{ document }}</span>
                      <i class="multiselect__tag-icon" @click="removeDocument(index)"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label>Process </label>
              <multiselect 
                id="processType" 
                v-model="form.processType" 
                track-by="processName" 
                label="processName"
                placeholder="Select Process..." 
                :custom-label="processTypeLabel" 
                :show-labels="false"
                :options="processTypeOptions" 
                :searchable="true" 
                :multiple="false" 
                :allow-empty="false"
                :close-on-select="true" 
                :class="{ 'is-invalid': submitted && $v.form.processType.$error }" 
                @input="changeProcessType()">
              </multiselect>
              <div v-if="submitted && $v.form.processType.$error" class="invalid-feedback">
                <span v-if="!$v.form.processType.required">This value is required.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div>
              <div class="d-flex justify-content-end mb-2">
                <button type="button" @click="$emit('refreshOptions');" class="btn btn-sm btn-info">
                  <i class="mdi mdi-refresh"></i>
                  Refresh Options
                </button>
              </div>
            </div>
            <template v-if="form.processType == null">
              <div class="border border-2 d-flex align-items-center justify-content-center" style="height: calc(100% - 50px);">
                <div class="d-flex align-items-center justify-content-center p-3">
                  <div class="font-size-14 text-center">
                    Please select Process to enable Action Request/Purpose and Destination fields.
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <b-collapse :visible="form.processType != null">
                <div v-if="form.processType != null">
                  <div class="mb-3">
                    <label>Action Request/Purpose </label>
                    <multiselect id="actionType" v-model="form.actionType" track-by="type" label="type"
                      placeholder="Select Action Request/Purpose..." :custom-label="actionTypeLabel" :show-labels="false"
                      :options="actionTypeOptions" :searchable="true" :multiple="false" :allow-empty="false"
                      :close-on-select="true" :class="{
                        'is-invalid': submitted && $v.form.actionType.$error
                      }">
                    </multiselect>
                    <b-collapse :visible="form.actionType && form.actionType.type == 'Others'">
                      <div v-if="form.actionType && form.actionType.type == 'Others'" class="mx-3 mt-2">
                        <input id="title" type="text" v-model="form.actionNeeded"
                          placeholder="Enter Action Request/Purpose..." class="form-control" :class="{
                            'is-invalid':
                              submitted &&
                              form.actionType.type == 'Others' &&
                              form.actionNeeded == ''
                          }" autocomplete="off" />
                      </div>
                    </b-collapse>
                    <div v-if="
                      submitted &&
                      ($v.form.actionType.$error ||
                        (form.actionType.type == 'Others' &&
                          form.actionNeeded == ''))
                    " class="invalid-feedback">
                      <span v-if="!$v.form.actionType.required">This value is required.</span>
                    </div>
                  </div>
                  <label>Destination </label>
                  <template v-if="loadCampus">
                    <div class="border border-2 d-flex align-items-center justify-content-center" style="height: 100px;">
                      <div class="d-flex align-items-center justify-content-center p-3">
                        <div class="font-size-14 text-center">
                          Loading {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} options...
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="border mb-3 px-3 py-2" style="border-radius: 5px">
                      <div class="mb-3">
                        <div class="d-flex justify-content-between">
                          <label>{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
                          <div class="form-check form-checkbox-outline form-check-success mb-0">
                            <input
                                type="checkbox"
                                id="showAll"
                                class="form-check-input"
                                v-model="showAllCampus"
                            />
                            <label
                                for="showAll"
                                class="form-check-label no-wrap"
                            >
                                Show All
                            </label>
                          </div>
                        </div>
                        <multiselect 
                            id="destinationCampus" 
                            v-model="form.destinationCampus" 
                            track-by="campus" label="campus"
                            :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" 
                            :options="campusOptions" 
                            :searchable="true" 
                            :multiple="false" 
                            :allow-empty="true"
                            :close-on-select="true" 
                            :class="{ 'is-invalid': submitted && $v.form.destinationCampus.$error }"
                            @input="changeDestinationCampus"
                            >
                        </multiselect>
                        <div v-if="submitted && $v.form.destinationCampus.$error" class="invalid-feedback">
                          <span v-if="!$v.form.destinationDeliveryUnit.required">This value is required.</span>
                        </div>
                      </div>
                      <b-collapse :visible="form.destinationCampus != null">
                        <div v-if="form.destinationCampus != null">
                          <div class="mb-3">
                            <label>Office </label>
                            <!-- <multiselect id="destinationDeliveryUnit" v-model="form.destinationDeliveryUnit" track-by="name"
                              label="name" placeholder="Select Office..." :custom-label="deliveryUnitLabel" :show-labels="false"
                              :options="form.destinationCampus.deliveryUnitOptions" :searchable="true" :multiple="false"
                              :allow-empty="false" :close-on-select="true"
                              @input="getDepartment(form.destinationDeliveryUnit.id)" :class="{
                                'is-invalid':
                                  submitted && $v.form.destinationDeliveryUnit.$error
                              }">
                            </multiselect>
                            <div v-if="submitted && $v.form.destinationDeliveryUnit.$error" class="invalid-feedback">
                              <span v-if="!$v.form.destinationDeliveryUnit.required">This value is required.</span>
                            </div> -->
                            <multiselect 
                              id="trackDestinationDeliveryUnitIds" 
                              v-model="form.trackDestinationDeliveryUnitIds" 
                              track-by="name"
                              label="name" 
                              placeholder="Select Office..." 
                              :custom-label="deliveryUnitLabel" 
                              :show-labels="false"
                              :options="form.destinationCampus.deliveryUnitOptions" 
                              :searchable="true" :multiple="true"
                              :close-on-select="false"
                              :class="{'is-invalid': submitted && form.trackDestinationDeliveryUnitIds.length == 0}"
                            >
                            </multiselect>
                            <div v-if="submitted && form.trackDestinationDeliveryUnitIds.length == 0" class="invalid-feedback">
                              This value is required.
                            </div>
                          </div>
                          <b-collapse :visible="form.destinationDeliveryUnit != null">
                            <div v-if="form.destinationDeliveryUnit != null">
                              <div class="mb-2">
                                <label>Department </label>
                                <multiselect id="destinationDepartment" v-model="form.destinationDepartment"
                                  track-by="departmentName" label="departmentName" placeholder="Select Department..."
                                  :custom-label="departmentLabel" :show-labels="false" :options="departmentOptions"
                                  :searchable="true" :multiple="false" :allow-empty="false" :close-on-select="true">
                                </multiselect>
                              </div>
                            </div>
                          </b-collapse>
                        </div>
                      </b-collapse>
                    </div>
                  </template>
                </div>
              </b-collapse>
            </template>
          </div>
        </div>
        <div class="mb-3 mt-2">
          <div class="row">
            <div class="col-md-6">
              <div class="d-flex float-end">
                <button type="button" @click="addDocu = true" class="btn btn-sm btn-warning" :id="`document-${form.id ? form.id : 'new'}`">
                 <i class="bx bx-paperclip"></i> Add {{ attachments.length ? 'More' : '' }} Documents
                </button>
                <upload-popover
                  :option="uploadOptions"
                  :sourceId="form.id ? form.id : 0"
                  @addToFiles="uploadedFiles"
                  @uploaded="pushToFiles"
                  :showPV="addDocu"
                  @closePopover="addDocu = false"
                  :dzId="`dropzone-document-${form.id ? form.id : 'new'}`"
                  :pvId="`document-${form.id ? form.id : 'new'}`"
              ></upload-popover>
              </div>
              <label class="mt-2">Attached Documents</label>
              <hr class="mt-1 mb-2" />
              <div style="max-height: 180px; overflow: auto">
                <div v-if="attachments && attachments.length">
                  <div class="d-flex justify-content-between align-items-center bg-warning bg-soft px-2 py-1 text-white rounded mb-1" v-for="(item, index) in attachments" :key="index">
                    <div>{{ item.description }}</div>
                    <a href="javascript: void(0);" class="text-danger line-height-1" @click="removeAttachment(item, index)" title="Remove Attachment">
                      <i class="bx bx-trash font-size-18"></i>
                    </a>
                  </div>
                </div>
                <i class="font-size-11" v-else>No Attached Documents</i>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex float-end">
                <button type="button" @click="getTracks" class="btn btn-sm btn-success">
                  <i class="bx bx-receipt"></i> Select Tracks
                </button>
              </div>
              <label class="mt-2">Link Track</label>
              <hr class="mt-1 mb-2" />
              <div style="max-height: 180px; overflow: auto" class="pe-2">
                <table v-if="form.tracks && form.tracks.length" width="100%">
                  <tbody>
                    <tr v-for="(item, index) in form.tracks" :key="index">
                      <td class="py-2">
                        <div class="d-flex">
                          <div class="me-3">{{ index + 1 }}.</div>
                          <div>
                            <small>{{ item.referenceNumber }}</small>
                            <div>{{ item.title }}</div>
                          </div>
                        </div>
                      </td>
                      <td class="py-2" style="width: max-content">
                        <a href="javascript: void(0);" class="text-danger" @click="form.tracks.splice(index, 1)">
                          <i class="bx bx-x font-size-18"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <i class="font-size-11" v-else>No Tracks Linked</i>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-2" />
        <div v-if="form.id" class="d-flex float-end gap-1">
          <button @click="onSubmit('update')" class="btn btn-primary">
            Update Draft
          </button>
          <button @click="onSubmit('send')" class="btn btn-success">
            Update & Send
          </button>
        </div>
        <div class="d-flex float-end gap-1" v-else>
          <button @click="onSubmit('create')" class="btn btn-primary">
            Create as Draft
          </button>
          <button @click="onSubmit('send')" class="btn btn-success">
            Create & Send
          </button>
        </div>
      </div>
      <Tracks ref="tracks" @dropMultiple="dropTracks($event)"></Tracks>
    </b-modal>
</template>